declare const __APP_VERSION__: string;

const Config = {
  get PUBLIC_URL() {
    return import.meta.env.BASE_URL;
  },
  get SERVER_URL() {
    return import.meta.env.REACT_APP_SERVER_URL;
  },
  get AUTH_SERVER_URL() {
    return import.meta.env.REACT_APP_AUTH_SERVER_URL;
  },
  get NODE_ENV() {
    return import.meta.env.MODE;
  },
  // NOTE: this must stay tied to PROD, not MODE. Under CRA every build target
  // (build:dev / build:staging / build:production) ran with NODE_ENV=production,
  // so DEBUG was false for all of them and only the dev server had it true.
  // `vite build --mode development` sets MODE='development' but PROD=true, so
  // checking MODE here would silently disable Sentry and GA on the dev deploy.
  get DEBUG() {
    return !import.meta.env.PROD;
  },
  get GA_TRACKING_ID() {
    return import.meta.env.REACT_APP_GA_TRACKING_ID;
  },
  get SENTRY_URL() {
    return import.meta.env.REACT_APP_SENTRY_URL;
  },
  get VERSION() {
    return 'v' + __APP_VERSION__;
  },
  get FOOTER_COPYRIGHT() {
    return new Date().getFullYear() + ' © Booking Autopilot - bookingautopilot.com';
  },
};

export default Config;
